import React from 'react';
import { Form2 } from '../../../toolympus/components/primitives/Forms2';
import { Buttons, EmptyState, LoadingIndicator, MoreActionsMenuButton, OccupyFreeSpace, PseudoLink2, SimpleDialog, useDialogState } from '../../../toolympus/components/primitives';
import { Badge, Button, IconButton, Typography } from '@mui/material';
import { OrgStructureProvider } from '../Structure';
import { AbsenceCalendar } from './Elements/AbsenceCalendar';
import { isAdmin, useAbsenceCalendar } from './data/useAbsenceCalendar';
import { HideOrUnhideStructureNodeDialog } from '../Structure/Elements/HideOrUnhideStructureNodeDialog';
import { Add, ArrowBackIos, ArrowForwardIos, Check, RefreshOutlined } from '@mui/icons-material';
import { HiddenStructureNodesDialog } from '../Structure/Elements/HiddenStructureNodesDialog';
import { CancelAbsenceDialog, CreateAbsenceDialog, EditAbsenceDialog } from './Elements/EditAbsenceDialog';
import { AbsenceStatsDialog } from './Elements/AbsenceStatsDialog';
import { useUser } from '../../../toolympus/userContext/UserContext';
import { useEditItem2 } from '../../../toolympus/api/useNewItem';
import { Employee } from '../Structure/types';
import { AbsenceEvent, AbsenceEventSchema } from './data/types';
import { TableForFields } from '../../../toolympus/components/schemed';
import { CalendarLegend } from './Elements/AbsenceCalendarLegend';
import { ActionTriggerEditButton } from '../../../toolympus/components/Actions';
import { AbsenceExtraQuotasDialog } from './Elements/AbsenceExtraQuotasDialog';

interface Props {
  
}

export const AbsenceCalendarPageMain = (props: Props) => {
  const data = useAbsenceCalendar();

  const legendDialog = useDialogState();
  const { user } = useUser();

  const employeeEventsList = useEditItem2<{ employee: Employee, events: AbsenceEvent[] }>({
  });

  return (<>
    <Form2
      noTitle
      background="panel"
      fitFullHeight
      formBodyProps={{
        style: { padding: 0 }
      }}
      // dimmed={data.editRecord.isEditing}
      // formHeaderProps={{
      //   onClick: () => data.editRecord.cancel(),
      // }}
      headerItems={<>
        <Typography variant="h4">Отсутствия / присутствия</Typography>

        <MoreActionsMenuButton
          icon={<Add />}
          actions={[
            ["remote", "+ добавить", () => data.newItem.start()],
          ]}
        />

        <OccupyFreeSpace />

        {(data.isLoading || data.orgStructureManagement.isLoading) && <LoadingIndicator sizeVariant="s" />}

        <IconButton size="small" color="primary" onClick={() => data.events.reload()}>
          <RefreshOutlined />
        </IconButton>
        <Button
          size="small"
          color={data.filters.includeCancelled.isOn ? "primary" : undefined}
          startIcon={data.filters.includeCancelled.isOn ? <Check /> : undefined}
          onClick={() => data.filters.includeCancelled.toggle()}
          >
          показать отмененные
        </Button>

        <Button
          size="small"
          color={data.filters.onlyMyDepartment.isOn ? "primary" : undefined}
          startIcon={data.filters.onlyMyDepartment.isOn ? <Check /> : undefined}
          onClick={() => data.filters.onlyMyDepartment.toggle()}
          >
          {data.hasUpcomingWarningMyDept
            ? (<Badge color="error" variant="dot">
              только мой отдел
            </Badge>)
            : "только мой отдел"}
        </Button>

        <Button
          size="small"
          onClick={() => data.calendar.goToToday()}
          >
          • сегодня
        </Button>


        <Buttons>
          <Button size="small" onClick={() => data.calendar.goToPrevMonth()} startIcon={<ArrowBackIos />}>
            {data.calendar.currentMonthMoment.clone().add(-1, "M").format("MMM").substring(0,3)}
          </Button>

          <Button size="small">
            {data.calendar.currentMonthMoment.clone().format("MMM").substring(0,3)}
          </Button>

          <Button size="small" onClick={() => data.calendar.goToNextMonth()} endIcon={<ArrowForwardIos />}>
            {data.calendar.currentMonthMoment.clone().add(+1, "M").format("MMM").substring(0,3)}
          </Button>

        </Buttons>
        
        {!!isAdmin(user) &&
          <ActionTriggerEditButton
            apiPath="/api/actions/trigger"
            triggers={[
              "project-status.logic.absence.absence-entities/absence-created",
              "project-status.logic.absence.absence-entities/absence-cancelled",
            ]}
            />}

        <MoreActionsMenuButton
          actions={[
            ["stats", "статистика", () => data.absenceStats.showForMe()],
            ["legend", "легенда", () => legendDialog.open()],
            user?.roles.includes("admin") ?
              ["edithidden", "скрытые", () => data.orgStructureManagement.editHidden.start()]
              : null,
          ]}
          />
      </>}
    >

    <AbsenceCalendar
      data={data}
      showEmployeeEventList={(employee,events) => employeeEventsList.startEditing({ employee, events })}
      />
      
    </Form2>

    <HideOrUnhideStructureNodeDialog
      data={data.orgStructureManagement.hideOrUnhide}
      />

    <CreateAbsenceDialog
      data={data.newItem}
      />


    <HiddenStructureNodesDialog
      data={data.orgStructureManagement.editHidden}
      doHideOrUnhide={data.orgStructureManagement.doHideOrUnhide}
      />

    <EditAbsenceDialog
      data={data.editItem}
      startCancel={item => data.cancelItem.startEditing({ ...item })}
      />

    <CancelAbsenceDialog
      data={data.cancelItem}
      />

    <SimpleDialog
      {...legendDialog}
      dialogTitle="Легенда"
      noSave
      save={() => {}}
      cancelLabel="закрыть"
      noFullscreen
    >
      <CalendarLegend />
    </SimpleDialog>

    <AbsenceStatsDialog
      {...data.absenceStats.dialog}
      isLoading={data.absenceStats.isLoading}
      item={data.absenceStats.item}
      />


    <SimpleDialog
      {...employeeEventsList.dialog}
      dialogTitle={`${employeeEventsList.item?.employee?.first_name || "..."} ${employeeEventsList.item?.employee?.last_name || ""}`}
      save={() => {}}
      noSave
      noFullscreen
      >
      {!!employeeEventsList.item &&
        <TableForFields
          data={employeeEventsList.item.events}
          fields={[
            ["start_date"],
            ["end_date"],
            ["kind"],
            ["cancelled_at"],
          ]}
          fieldElement={f => {
            switch(f) {
              case "kind":
                return (r,s,o) => <PseudoLink2 onClick={() => data.editItem.startEditing({ ...r })}>{o}</PseudoLink2>
              case "cancelled_at":
                return (r) => r.cancelled_at ? <Check color="action" fontSize="small" /> : <></>
            }
          }}
          schema={AbsenceEventSchema}
          emptyState={<EmptyState />}
          />}
    </SimpleDialog>

    <AbsenceExtraQuotasDialog
      data={data.extraQuotas}
      />
  </>);
}


export const AbsenceCalendarPage = () => {
  return (
    <OrgStructureProvider>
      <AbsenceCalendarPageMain />
    </OrgStructureProvider>
  )
}